import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as HeaderModule from "@/redux/modules/value/header/header.module";
import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";
import * as ProfileSidebarModule from "@/redux/modules/value/profileSidebar/profileSidebar.module";

import _Hamburger from "./hamburger.component";

const Hamburger = () => {
    const dispatch = useThunkDispatch();
    const sidebarActive = useSelector(HeaderSelectors.isSidebarActive);

    const update = (data: any) => {
        dispatch(HeaderModule.update(data));
    };

    const updateProfileSidebar = (data: any) => {
        dispatch(ProfileSidebarModule.update(data));
    };

    return (
        <_Hamburger
            active={!!sidebarActive}
            handleClick={() => {
                update({ sidebarActive: !sidebarActive });
                updateProfileSidebar({ active: false });
            }}
        />
    );
};

export { Hamburger };
